import { Typography, Button } from "antd";
import { Home, AlertTriangle } from "lucide-react";
import Particles from "../Particels";

const { Title, Text } = Typography;

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 overflow-hidden relative">
      <Particles />

      <div className="text-center z-10 px-4 sm:px-6 lg:px-8">
        <AlertTriangle className="mx-auto h-24 w-24 text-[#FF7051] mb-8" />
        <Title level={1} className="text-4xl sm:text-6xl font-bold mb-4">
          404
        </Title>
        <Title level={2} className="text-2xl sm:text-3xl font-semibold mb-4">
          Oops! Page not found
        </Title>
        <Text className="text-lg text-gray-600 mb-8 block">
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </Text>
        <a href="/">
          <Button
            type="primary"
            size="large"
            icon={<Home className="mr-2 h-5 w-5" />}
            className="bg-[#FF7051] hover:!bg-[#FF7051]/90"
          >
            Go back home
          </Button>
        </a>
      </div>
    </div>
  );
};

export default NotFound;
